export default __webpack_public_path__ + "static/media/linkedin.decae9f7.svg";